import React, { useState } from 'react';

import App from '../components/common/App';
import HomeContent from '../components/content/HomeContent';
import settings from '../components/common/settings';
import { graphql, useStaticQuery } from 'gatsby';

import GoogleReCaptchaComponent from '../components/common/ReCaptcha/GoogleReCaptchaComponent';
import ContactSupportDialogController from '../components/dialogs/ContactSupportDialog/ContactSupportDialogController';


export default function Index() {
  const [contactSupportDialog, setContactSupportDialog] = useState(false);

  const data = useStaticQuery(
    graphql`
    query {
      logo_image: file(relativePath: { eq: "snn_logo.png" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, formats: [AUTO, WEBP])
        }
      }
    
      dmitri_lihhatsov_photo: file(
        relativePath: { eq: "Dmitri_Lihhatsov_Peschici_square.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, formats: [AUTO, WEBP])
        }
      }
    
      background_image: file(
        relativePath: { eq: "federico-beccari-544724-unsplash.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, formats: [AUTO, WEBP], quality: 90)
        }
      }
    }
`
  )

  return (
    <App>

      <GoogleReCaptchaComponent component="homepage" />

      <HomeContent title={settings.title} 
        description={settings.description}
        homeURL={settings.homeURL}
        onContactSupportClick={() => setContactSupportDialog(true)}
        data={data}
      />

      <ContactSupportDialogController showDialog={contactSupportDialog} showDialogController={setContactSupportDialog} />

    </App>
  );
}
